import { render, staticRenderFns } from "./BcProgress.vue?vue&type=template&id=7aff5e89&scoped=true"
import script from "./BcProgress.vue?vue&type=script&lang=js"
export * from "./BcProgress.vue?vue&type=script&lang=js"
import style0 from "./BcProgress.vue?vue&type=style&index=0&id=7aff5e89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aff5e89",
  null
  
)

export default component.exports